import script from "./ActivateAccountView.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivateAccountView.vue?vue&type=script&setup=true&lang=js"

import "./ActivateAccountView.vue?vue&type=style&index=0&id=bd7313b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd7313b4"]])

export default __exports__